import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { L as Label } from '../index-c4501d32.js';

var styles = {
raw: ".hcr-select-group-1-6-0{position:relative}.hcr-select-group__items-1-6-0{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;position:relative;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:1px;border-left:1px solid #c8c8c8;border-radius:5px;overflow:hidden;list-style-type:none}.hcr-select-group__item-1-6-0{min-width:44px;height:44px;margin-top:-1px;border:1px solid #c8c8c8;border-left:0;line-height:44px;text-align:center;overflow:hidden}@media (min-width:1200px){.hcr-select-group__item-1-6-0{min-width:36px;height:36px;line-height:36px}}.hcr-select-group__item-1-6-0:last-child{border-radius:0 5px 5px 0}.hcr-select-group__item-1-6-0 input{position:absolute;cursor:pointer;opacity:0}.hcr-select-group__item-1-6-0 label{display:block;padding:0 12px;background:#fff;cursor:pointer}.hcr-select-group__item-1-6-0 input:checked+label{background:#73d700;color:#fff}",
map:{"hcr-select-group":"hcr-select-group-1-6-0","hcr-select-group__items":"hcr-select-group__items-1-6-0","hcr-select-group__item":"hcr-select-group__item-1-6-0"}};

var bem = Bem('select-group', styles);
var SelectGroup = function SelectGroup(_ref) {
  var multi = _ref.multi,
      label = _ref.label,
      id = _ref.id,
      options = _ref.options,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["multi", "label", "id", "options", "extraClasses"]);

  return React.createElement("div", _extends({
    className: bem.b(false, extraClasses)
  }, rest), label && React.createElement(Label, {
    labelFor: label,
    extraClasses: bem.e('label'),
    id: id,
    text: label
  }), React.createElement("ul", {
    className: bem.e('items')
  }, options && options.map(function (_ref2) {
    var subId = _ref2.id,
        name = _ref2.name,
        value = _ref2.value,
        lab = _ref2.label,
        restInOption = _objectWithoutProperties(_ref2, ["id", "name", "value", "label"]);

    return React.createElement("li", {
      className: bem.e('item'),
      key: subId
    }, React.createElement("input", _extends({
      type: multi ? 'checkbox' : 'radio',
      value: value,
      name: name,
      id: subId
    }, restInOption)), React.createElement("label", {
      htmlFor: subId
    }, lab));
  })));
};
SelectGroup.displayName = 'SelectGroup';
SelectGroup.defaultProps = {
  extraClasses: '',
  multi: false
};
SelectGroup.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Overall label for the group, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref3) {
    var ariaLabel = _ref3['aria-label'],
        _label = _ref3.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** ID for the overall label */
  id: PropTypes.string.isRequired,

  /** Allow multiselection (checkboxes) */
  multi: PropTypes.bool,

  /** Options for the group */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
};
var selectGroup = Injecss(SelectGroup, styles);

export { selectGroup as SelectGroup };
